const WEATHER_ICONS = {
  clear: 'mdi-weather-sunny',
  partlyCloudy: 'mdi-weather-partly-cloudy',
  cloudy: 'mdi-weather-cloudy',
  fog: 'mdi-weather-fog',
  rain: 'mdi-weather-rainy',
  snow: 'mdi-weather-snowy',
  storm: 'mdi-weather-lightning',
}

function mapWeatherCodeToIcon(code) {
  if (code === 0) return WEATHER_ICONS.clear
  if (code >= 1 && code <= 2) return WEATHER_ICONS.partlyCloudy
  if (code === 3) return WEATHER_ICONS.cloudy
  if (code >= 45 && code <= 48) return WEATHER_ICONS.fog
  if (code >= 51 && code <= 67) return WEATHER_ICONS.rain
  if (code >= 71 && code <= 77) return WEATHER_ICONS.snow
  if (code >= 80 && code <= 82) return WEATHER_ICONS.rain
  if (code >= 95) return WEATHER_ICONS.storm
  return WEATHER_ICONS.cloudy
}

export async function getWeather(latitude, longitude) {
  const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error('No se pudo obtener el clima')
  }

  const data = await response.json()

  return {
    temperature: Math.round(data.current_weather.temperature),
    icon: mapWeatherCodeToIcon(data.current_weather.weathercode),
  }
}